export const API     = {
    PROBLEM_TYPE_SCHEME_REFERENCE: "commercieel",
    FILTER_REFERENCE: "REB-REP-273",
    COMPLETE_RESULT_REFERENCE: "HOO-REP-106",
    EXTERNAL_SOURCE_REFERENCE: "HOORNE",
    BASE_URL: "/wp-json/repair-form/v1/",
    CREATE_UPDATE: "createupdate",
    COMPLETE_REPORT_RESULT: "completereportresult",
    UPLOAD: "upload/",
}
export const Notifications =  {
    NO_ADDRESS: "Wij hebben geen gegevens gevonden met deze adresgegevens.",
    ADD_ADDRESS_DATA: "Vul a.u.b. de nummer toevoegingen in om het adres te verfijnen.",
    NO_PHOTO_FILE: "Voeg tenminste één foto toe bij documenten om de melding in te dienen",
    HIGH_PRIO: "Beste huurder/melder uw melding heeft hoge prioriteit!! Graag bellen met ({aannemer} - {tel}). Dank voor uw medewerking!",
    ERROR: "Er is een fout opgetreden. Probeer het later opnieuw. Foutcode: ",
    EMAIL_ADDRESS_NOT_VALID: "Het ingevoerde emailadres lijkt geen geldig emailadres.",
    EMAIL_ADDRESS_ALT_CONTACT_NOT_VALID: "Het ingevoerde emailadres van het alternatief contact lijkt geen geldig emailadres.",
}

export const Steps = {
    LOCATION: "location",
    REPORT_DATA: "reportData",
    CONFIRM: "confirm",
    CONFIRMED: "confirmed",
}
export const FieldOptions = {
    AREA_NUMBER: "areaNumber", // VHE-referentie, zoals eerder opgehaald
    PROBLEM_TYPE_SCHEME_REFERENCE: "problemTypeSchemeReference", // Vaste waarde -> 'commercieel'
    PROBLEM_TYPE_REFERENCE: "ProblemTypeReference", // Referentie naar bovenliggende niveau,om niveau er onder te bepalen.
    EXTERNAL_SOURCE: "reb-WS-ExternalResource", // Externe bron -> Fixed ‘HOORNE’
    UNIQUE_REF_SOUR: "reb-WS-VHEReferenceWebservice", //Unieke referentie bron
    REF_VHE: "reb-WS-VHEReferenceWebservice", // VHE Referentie
    REF_PROBLEM_TYPE: "reb-WS-LowestLevelOfProblemType", // Referentie probleemtype
    SHORT_DESCRIPTION: "reb-WS-NameRequestWebservice", // Korte omschrijving
    DESCRIPTION: "reb-WS-DescriptionReqWebservice", // Omschrijving probleem
    NAME: "reb-WS-ContactPersonName", // Naam contactpersoon
    ADDRESS: "address", // Adres contactpersoon
    NR: "nr", // Huisnummer contactpersoon
    ADDRESS_LETTER: "addressLetter", // Huisnummer toevoeging contactpersoon
    ADDRESS_ADDITION: "addressAddition", // Adres toevoeging contactpersoon
    CITY: "city", // Woonplaats contactpersoon
    POSTAL_CODE: "postalCode", // Postcode contactpersoon
    PHONE: "reb-WS-ContactPersonPhone", // Telefoonnummer contactpersoon
    EMAIL: "reb-WS-ContactPersonEmail", // Emailadres contactpersoon
    SALUTATION: "hoorne-Salutation", // Aanhef contactpersoon
    COMPANY: "hoorne-Company", // Bedrijf contactpersoon
    AGREED_AVG: "hoorne_avg_akkoord", // AVG akkoord
    NAME_ALTERNATIVE_CONTACT: "hoorne-NameAlternativeContact", // Naam afwijkende contactpersoon
    PHONE_ALTERNATIVE_CONTACT: "hoorne-PhoneAlternativeContact", // Telefoonnummer afwijkende contactpersoon
    EMAIL_ALTERNATIVE_CONTACT: "hoorne-EmailAlternativeContact", // Email afwijkende contactpersoon
    COMPANY_ALTERNATIVE_CONTACT: "hoorne-CompanyAlternativeContact", // Bedrijf afwijkende contactpersoon
}
